/* eslint-disable @typescript-eslint/default-param-last */
import { TESTING_SET_CREATED_TEXTURES, TESTING_SET_TESTED_TEXTURE } from './actions';

const initialState = {
  testedTexture: undefined,
  createdTextures: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TESTING_SET_CREATED_TEXTURES:
      return {
        ...state,
        createdTextures: action.payload,
      };

    case TESTING_SET_TESTED_TEXTURE:
      return {
        ...state,
        testedTexture: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
